// ContactItem.tsx
import { motion } from 'framer-motion';

interface ContactItemProps {
  icon: JSX.Element;
  bg: string;
  title: string;
  content: string;
}

const ContactItem: React.FC<ContactItemProps> = ({ icon, bg, title, content }) => {
  return (
    <motion.div
      className="flex items-start gap-6 p-8 bg-white rounded-2xl shadow-lg border border-[#1e3a8a]/10 hover:shadow-xl transition-all"
      whileHover={{ y: -5 }}
    >
      <div className={`p-4 ${bg} rounded-xl`}>
        {icon}
      </div>
      <div>
        <h3 className="text-xl font-semibold text-[#1e3a8a]">{title}</h3>
        <p className="mt-2 text-[#1c3d6e]">{content}</p>
      </div>
    </motion.div>
  );
};

export default ContactItem;
